import { render, staticRenderFns } from "./AddressText.vue?vue&type=template&id=736eea62&"
import script from "./AddressText.vue?vue&type=script&lang=js&"
export * from "./AddressText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports